<div class="container">
  <div class="burial-title">
    {{ burialTitle }}
  </div>
  <div class="burial-address">
    {{ burialAddress }}
  </div>
  <div class="status">
    {{ statusTitle }}
  </div>
  <div class="current-stage">
    {{ currentStage }}
  </div>

  <div class="state-display">
    <div
      class="scroll-icon left-scroll-arrow"
      [hidden]="!(initialScrollPosition > 0)"
    >
      <ds-icon
        class="left-icon icon-margin"
        [color]="'dark-lg-soot'"
        [name]="'left'"
        (click)="scrollLeft()"
      ></ds-icon>
    </div>

    <div #currentStatus class="current-status hor-scroll-wrap">
      <div
        class="status-margin"
        [attr.id]="'status-indicator-' + (i + 1)"
        *ngFor="let status of statusList; let i = index"
      >
        <ucx-status-indicator
          [burialStage]="burialStage"
          [burialClosedText]="burialClosedText"
          [itemIndex]="i + 1"
          [isLast]="isLast(i)"
          [currentStatusIndex]="currentStatusIndex"
          [burialSeasonClosed]="burialSeasonClosed"
          [statusValue]="status.statusValue"
          [statusState]="status.statusState"
          [onEmitStatus]="setCurrentStage"
          [onEmitStage]="setStageTitle"
        >
        </ucx-status-indicator>
      </div>
    </div>
    <div
      class="right-scroll-arrow"
      [hidden]="
        dynamicCurrentStatusScrollAreaWidth >=
        initialCurrentStatusScrollAreaWidth - 41
      "
    >
      <ds-icon
        class="scroll-icon"
        [name]="'right'"
        [color]="'dark-lg-soot'"
        (click)="scrollRight()"
      ></ds-icon>
    </div>
  </div>
</div>
